module.exports = __webpack_public_path__ + "static/media/profile_avatar.0c675689.svg";